import React from "react";
// import TableComandas from "../components/TableComandas";
import AppProductoReactTable from "../table/AppProductoReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Productos = () => {
  return (
    <>
      <AppProductoReactTable />
      {/* <TableComandas /> */}
      {/* <Footer /> */}
    </>
  );
};

export default Productos;
